var exports = {
  "h_": "middlePaneWrapper__YquUVt",
  "R_": "heading__vDybrY",
  "IW": "middlePaneGrid__fv41eg",
  "Sl": "backLink__-rBHdV",
};

module.exports = exports;
